<template>
  <footer class="pt-5 footer ">
    <section class="container">
      <div class="email-box">
        <div>
          <h6 class=" font-weight-bolder fontsize-heavy text-pink-theme2">
            عضویت در خبرنامه
          </h6>
          <p class="text-pink-theme2 fontsize-small ">
            با اشتراک خبرنامه هفتگی ما از تخفیف ها , اخبارها و مطالب با خبر
            شوید.
          </p>
        </div>
        <form id="sendEmailForm" class="w-100 d-flex justify-content-between">
          <input
            type="text"
            v-model="email"
            class="bg-white w-100  px-2  fontsize-mini"
            placeholder="ایمیل خود را وارد کنید..."
          />
          <button
            style="font-weight: 600;"
            @click.prevent="sendEmail()"
            :class="{ disabled: disabled }"
            class="
              fontsize-mini
              text-white
              
              px-5
              align-self-end
              newsletter-btn
              bg-pink-theme2
            "
          >
            عضویت
          </button>
        </form>
      </div>
      <div class="down-footer">
        <div class=" address-box">
          <AtlasLogo class="mb-3 logo-footer" />

          <div class="d-flex align-items-center" style="gap: 6px;">
            <template v-if="settings">
              <svg
                width="23"
                height="23"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
                  fill="#292D32"
                ></path>
                <path
                  d="M18.5 9.75C18.09 9.75 17.75 9.41 17.75 9C17.75 8.64 17.39 7.89 16.79 7.25C16.2 6.62 15.55 6.25 15 6.25C14.59 6.25 14.25 5.91 14.25 5.5C14.25 5.09 14.59 4.75 15 4.75C15.97 4.75 16.99 5.27 17.88 6.22C18.71 7.11 19.25 8.2 19.25 9C19.25 9.41 18.91 9.75 18.5 9.75Z"
                  fill="#292D32"
                ></path>
                <path
                  d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9C21.25 5.55 18.45 2.75 15 2.75C14.59 2.75 14.25 2.41 14.25 2C14.25 1.59 14.59 1.25 15 1.25C19.27 1.25 22.75 4.73 22.75 9C22.75 9.41 22.41 9.75 22 9.75Z"
                  fill="#292D32"
                ></path>
              </svg>
              <a
                :href="`tel:${settings.site.mobile}`"
                class="fontsize-small text-color-444 d-md-inline-block d-sm-block tel"
                >{{ settings.site.mobile }}</a
              >
            </template>
            <template v-else>
              <span
                ><b-skeleton width="105px" class="d-inline-block mr-2"
              /></span>
              <span
                ><b-skeleton width="105px" class="d-inline-block mr-2"
              /></span>
            </template>
          </div>

          <div class="d-flex align-items-center" style="gap: 6px;">
            <template v-if="settings">
              <svg
                width="23"
                height="23"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <a
                :href="`mailto:${settings.site.email}`"
                class="fontsize-small text-color-444 d-md-inline-block d-sm-block email"
                >{{ settings.site.email }}</a
              >
            </template>
            <template v-else>
              <span
                ><b-skeleton width="105px" class="d-inline-block mr-2"
              /></span>
              <span
                ><b-skeleton width="105px" class="d-inline-block mr-2"
              /></span>
            </template>
          </div>

          <div class="d-flex align-items-center" style="gap: 6px;">
            <svg
              width="23"
              height="23"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9989 14.1714C9.86891 14.1714 8.12891 12.4414 8.12891 10.3014C8.12891 8.16141 9.86891 6.44141 11.9989 6.44141C14.1289 6.44141 15.8689 8.17141 15.8689 10.3114C15.8689 12.4514 14.1289 14.1714 11.9989 14.1714ZM11.9989 7.94141C10.6989 7.94141 9.62891 9.00141 9.62891 10.3114C9.62891 11.6214 10.6889 12.6814 11.9989 12.6814C13.3089 12.6814 14.3689 11.6214 14.3689 10.3114C14.3689 9.00141 13.2989 7.94141 11.9989 7.94141Z"
                fill="#292D32"
              ></path>
              <path
                d="M12.0016 22.76C10.5216 22.76 9.03164 22.2 7.87164 21.09C4.92164 18.25 1.66164 13.72 2.89164 8.33C4.00164 3.44 8.27164 1.25 12.0016 1.25C12.0016 1.25 12.0016 1.25 12.0116 1.25C15.7416 1.25 20.0116 3.44 21.1216 8.34C22.3416 13.73 19.0816 18.25 16.1316 21.09C14.9716 22.2 13.4816 22.76 12.0016 22.76ZM12.0016 2.75C9.09164 2.75 5.35164 4.3 4.36164 8.66C3.28164 13.37 6.24164 17.43 8.92164 20C10.6516 21.67 13.3616 21.67 15.0916 20C17.7616 17.43 20.7216 13.37 19.6616 8.66C18.6616 4.3 14.9116 2.75 12.0016 2.75Z"
                fill="#292D32"
              ></path>
            </svg>
            <span
              v-if="settings"
              class="fontsize-small text-color-444 text-justify"
              >{{ settings.site.address }}</span
            >
            <b-skeleton v-else width="270px" />
          </div>

          <sotialNetworks class=" sotial-networks-footer" />
        </div>

        <div class="menu-footer">
          <!-- <menuFooter :list="footerMenu" v-if="footerMenu" title="دسترسی " /> -->
          <menuFooter v-if="menu" :list="menu.slice(1, 4)" title="دسته بندی " />
          <menuFooter v-if="footerMenu" :list="footerMenu" title="دسته بندی " />
          <menuFooter :list="menu3" title="دسترسی سریع " />
          <div class="d-flex flex-column enamad">
            <!-- <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=277053&Code=hKCti70V7UYV5uefXAyM"
            >
              <img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=277053&Code=hKCti70V7UYV5uefXAyM"
                alt=""
                style="cursor:pointer"
                code="hKCti70V7UYV5uefXAyM"
              />
            </a> -->
            <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=563829&Code=rHgFWFiNVcYUGPo1rLx8elEY87lDq9Jw"
              ><img
                referrerpolicy="origin"
                src="@/assets/images/enamad.webp"
                alt=""
                style="cursor:pointer"
                code="rHgFWFiNVcYUGPo1rLx8elEY87lDq9Jw"
            /></a>
            <figure>
              <img src="@/assets/images/test/samandehi.png" />
            </figure>
          </div>
        </div>
      </div>
    </section>
    <section class=" bottom-footer">
      <div
        class=" container d-flex justify-content-center text-sm-right text-center "
      >
        <svg
          class="d-sm-inline-block d-none"
          height="20"
          viewBox="0 0 512 512"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#000"
            d="m178.925781 177.925781c-42.5 42.5-42.5 111.648438 0 154.148438s111.648438 42.5 154.148438 0c7.8125-7.8125 20.476562-7.8125 28.285156 0s7.808594 20.476562 0 28.285156c-29.046875 29.046875-67.203125 43.570313-105.359375 43.570313s-76.3125-14.523438-105.359375-43.570313c-58.09375-58.097656-58.09375-152.625 0-210.71875 58.097656-58.09375 152.625-58.09375 210.71875 0 7.8125 7.808594 7.8125 20.472656 0 28.285156-7.808594 7.808594-20.472656 7.808594-28.285156 0-42.5-42.5-111.648438-42.5-154.148438 0zm258.09375-102.945312c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469 46.8125 0 92.617188-12.757812 132.460938-36.894531 9.449218-5.722657 12.46875-18.019531 6.746093-27.46875-5.726562-9.449219-18.023437-12.46875-27.46875-6.742188-33.59375 20.347657-72.234375 31.105469-111.738281 31.105469-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216c0 42.589844-12.664062 84.042969-36.625 119.882812-6.140625 9.183594-3.671875 21.605469 5.507812 27.742188 9.1875 6.140625 21.605469 3.671875 27.742188-5.507812 28.378906-42.441407 43.375-91.585938 43.375-142.117188 0-68.378906-26.628906-132.667969-74.980469-181.019531zm0 0"
          />
        </svg>
        <p class="fontsize-small Designed m-0 mr-2 ">
          <span>
            تمامی حقوق این سایت مربوط به سایت چیلک لند می باشد .
          </span>
          <span>
            طراحی شده:
            <a
              class="font-bold"
              style=" color: var(--pink-theme2); font-size: 16px; font-weight: 900;"
              target="_blank"
              href="https://shetabit.com/"
              >شتاب</a
            >
          </span>
        </p>
      </div>
    </section>
  </footer>
</template>

<script>
// import AtlasLogoFooter from "@/parts/Front/components/AtlasLogoFooter";
import AtlasLogo from "@/parts/Front/components/AtlasLogo";

import sotialNetworks from "./sotialNetworks.vue";
import findUrl from "@/libraries/links/LinkResolver";
import DynamicLinker from "./DynamicLinker";
import menuFooter from "./menuFooter.vue";
import { BSkeleton } from "bootstrap-vue";

export default {
  name: "Footer",
  components: {
    DynamicLinker,
    BSkeleton,
    sotialNetworks,
    // AtlasLogoFooter,
    AtlasLogo,
    menuFooter,
  },
  created() {
    if (!this.footerMenu) this.$store.dispatch("front/getMenu", "footer");
    if (!this.settings)
      this.$store.dispatch("front/getMainContent", { route: "get-settings" });
  },
  computed: {
    footerMenu() {
      console.log(this.$store.getters["front/getMenuFooter"], "getMenuFooter");
      return this.$store.getters["front/getMenuFooter"];
    },
    menu() {
      console.log(this.$store.getters["front/getMenuHeader"], "getMenuHeader");
      return this.$store.getters["front/getMenuHeader"];
    },
    // دریافت محتوای درخواست هوم
    settings() {
      return this.$store.getters["front/getSettings"];
    },
  },
  data() {
    return {
      email: null,
      disabled: false,
      menu1: [
        { title: "نحوه ثبت سفارش" },
        { title: "نحوه لغو سفارش" },
        { title: "نحوه ویرایش سفارش" },
        { title: "کدرهگیری پستی" },
      ],
      menu2: [
        { title: "باشگاه مشتریان" },
        { title: "مشاوره رایگان" },

        { title: "پشتیبانی فنی" },
        { title: "شرایط ارسال" },
      ],
      menu3: [
        { title: "تماس با ما", linkable_type: "Custom\\ContactUs" },
        { title: "درباره ما", linkable_type: "Custom\\AboutUs" },

        { title: "وبلاگ", linkable_type: "Modules\\Blog\\Entities\\Post" },
      ],
    };
  },
  methods: {
    findUrl,
    sendEmail() {
      if (!this.email) {
        return window.swal({
          title: "خطا!",
          text: "لطفا ایمیل خود را وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      } else if (!this.validEmail(this.email)) {
        return window.swal({
          title: "خطا!",
          text: "لطفا فرمت ایمیل خود را به درستی وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      }
      const fromData = new FormData();
      fromData.append("email", this.email);
      this.disabled = true;
      this.$axios.post("/front/newsletters", fromData).then((response) => {
        this.disabled = false;
        this.email = null;
        window.swal({
          title: "تبریک",
          text: "ایمیل شما برای عضویت در خبرنامه ما ثبت سیستم شد",
          icon: "success",
          timer: 2000,
        });
      });
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped>
footer {
  /* background-color: rgb(236, 236, 236);*/
  background-color: var(--pink-theme1);
}

.bottom-footer {
  /*margin-top: 2rem;*/
  /*padding-top: 2rem;*/
  /*border-top: 1px solid rgba(118, 118, 118, .2);*/
  padding: 20px 0 20px;
  border-top: 1px solid var(--pink-theme2);
  margin-top: 10px;
}

.down-footer {
  display: grid;
  grid-template-columns: 30% 70%;
  gap: 1rem;
  margin-top: 6rem;
}

.down-footer .address-box {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.menu-footer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

#sendEmailForm {
  gap: 1.5rem;
}

.email-box {
  width: 60%;
  margin: 0 auto;
  text-align: center;
}

#sendEmailForm input,
.newsletter-btn {
  height: 54px;
}
#sendEmailForm input {
  border: #fff;
}
#sendEmailForm input::placeholder {
  color: var(--pink-theme2);
}
.tel:hover {
  color: var(--pink-theme2);
}

.email:hover {
  color: var(--pink-theme2);
}

.enamad img {
  width: 100px;
  justify-content: space-between;
  gap: 2rem;
}

@media screen and (max-width: 1300px) {
  .email-box {
    width: 80%;
  }
}

@media screen and (max-width: 1024px) {
  .down-footer {
    grid-template-columns: 100%;
    margin-top: 3rem;
  }

  .menu-footer {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2rem;
  }

  .email-box {
    width: 100%;
  }

  .logo-footer {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .down-footer .address-box {
    gap: 1.5rem;
  }
}

@media screen and (max-width: 768px) {
  footer {
    padding-bottom: 3.5rem;
  }
  #sendEmailForm input,
  .newsletter-btn {
    height: 45px;
  }

  .newsletter-btn {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  #sendEmailForm input {
    flex-grow: 1;
  }

  #sendEmailForm {
    gap: 1rem;
  }

  .enamad {
    flex-direction: row !important;
    gap: 1.5rem;
    margin-top: 0;
  }

  .menu-footer {
    grid-template-columns: repeat(1, 1fr);
  }

  .enamad img {
    width: 80px;
  }
}

@media screen and (max-width: 500px) {
  #sendEmailForm {
    gap: 1rem;
    flex-direction: column;
    justify-content: center !important;
  }

  .newsletter-btn {
    align-self: center !important;
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  .Designed {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
}

/*.logo-footer {
  width: 180px;
  height: 32px;
  margin: 0 !important;
}
.footer {
  background-color: #000;
}
.contant-footer {
  display: grid;
  grid-template-columns: 56% 44%;
}
.right {
  width: 100%;
  height: 100%;
  padding: 0 200px 0 130px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.left {
  width: 100%;
  height: 100%;
  background-color: blue;
  position: relative;
}
.gallery-footer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 600px;
}
.instagram-box {
  background-color: #fff;
  text-align: center;
  width: 240px;
  height: 240px;
  margin: auto;
  padding: 43px 20px 31px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.instagram-box h6 {
  color: #000;
  font-weight: 900;
  font-size: 18px;
}
.instagram-box p {
  color: #666;
}
.figure-gallery {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.image-gallery {
  width: 100%;
  height: 100%;
  transition: all 0.5s;
}
.figure-gallery:nth-child(odd):hover .image-gallery {
  transform: scale(1.3) rotate(-10deg);
}
.figure-gallery:nth-child(even):hover .image-gallery {
  transform: scale(1.3) rotate(10deg);
}
.top-rigth {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 30px;
}
.center-rigth {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.bottom-rigth {
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
@media screen and (max-width: 1300px) {
  .right {
    padding: 0 100px 0 60px;
  }
  .logo-footer {
    width: 160px;
    height: 32px;
  }
}
@media screen and (max-width: 1200px) {
  .instagram-box {
    width: 210px;
    height: 210px;
    padding: 30px 20px 20px;
  }
}
@media screen and (max-width: 1024px) {
  .contant-footer {
    display: grid;
    grid-template-columns: 100%;
    gap: 3rem;
  }
  .footer {
    padding-top: 0 !important;
    padding-bottom: 4rem !important;
  }
  .gallery-footer {
    height: auto;
  }
  .right {
    order: 1;
    gap: 4rem;
  }
}
@media screen and (max-width: 768px) {
  .center-rigth {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 2rem;
  }
  .right {
    padding: 0 25px;
  }
  .top-rigth {
    flex-direction: column;
    gap: 30px;
    align-items: start;
  }
}
@media screen and (max-width: 639px) {
  .instagram-box {
    width: 190px;
    height: 190px;
    padding: 26px 20px 26px;
  }
  .instagram-box h6 {
    color: #000;
    font-weight: 900;
    font-size: 16px;
  }
  .instagram-box p {
    font-size: 14px;
  }
  .center-rigth {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 2rem;
    column-gap: 3rem;
  }
}*/
/*.imgSkeleton {
  height: 70px;
}

.errorEmail {
  border-bottom: 1px solid red;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.newsletter-btn {
  background: var(--color-theme);
}
@media (min-width: 1024px) {
  .footer-call-location {
    position: relative;
  }
  .enamad-container {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}
}*/
</style>

<style>
.logo-footer img {
  mix-blend-mode: darken;
}

.sotial-networks-footer a {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ddd;
  display: grid;
  place-items: center;
  transition: all 0.4s ease-in-out;
}

.sotial-networks-footer a:hover {
  background-color: var(--orang-theme);
  border: 1px solid var(--orang-theme);
  box-shadow: 0 0 8px 0 var(--orang-theme);
}

.sotial-networks-footer.sotial-networks a svg path {
  transition: all 0.4s ease-in-out;
  fill: #000;
}

.sotial-networks-footer.sotial-networks a:hover svg > path {
  fill: #fff !important;
}
</style>
